import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      width: "100%",
      minHeight: "100vh",
      height: "fit-content",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center"
    },
    mainPanel: {
      width: 400,
      background: "transparent",
      marginBottom: "56px"
    },
    headTextLogo: {
      margin: "5px auto 96px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      transition: "all 0.5s ease",
      width: "350px"
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      padding: "5px 35px",
      paddingLeft: 0,
      borderRight: "solid 1px #E41B17"
    },
    logo: {
      marginLeft: 20
    },
    footer: {
      color: theme.palette.grey[800],
      marginBottom: "1rem",
      textAlign: "center",
      width: "100%"
    }
  }),
  { name: "PlainLayoutStyle" }
);

export default useStyles;
